function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  viewBox: "-250 -250 1000 1000",
  xmlnsXlink: "http://www.w3.org/1999/xlin"
}, props), /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#90C8EC"
  },
  cx: 256.001,
  cy: 145.733,
  r: 137.621
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#CAE9F7"
  },
  d: "M274.151,192.01h-88.626c-11.032,0-19.978-8.945-19.978-19.978v-52.164 c0-11.033,8.946-19.978,19.978-19.978H326.48c11.033,0,19.976,8.945,19.976,19.978v52.164c0,11.033-8.943,19.978-19.976,19.978 h-24.207"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#CAE9F7"
  },
  d: "M288.182,283.362h-64.365c-31.6,0-57.214,25.617-57.214,57.215v100.046h178.795V340.577 C345.398,308.98,319.782,283.362,288.182,283.362z"
})), /*#__PURE__*/React.createElement("rect", {
  x: 166.607,
  y: 389.046,
  style: {
    "fill": "#90C8EC"
  },
  width: 178.797,
  height: 51.575
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#578CAD"
  },
  d: "M166.603,440.624v43.286c0,11.032,8.945,19.978,19.979,19.978h14.433 c11.032,0,19.978-8.946,19.978-19.978v-43.286H166.603z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#578CAD"
  },
  d: "M291.013,483.91c0,11.032,8.943,19.978,19.978,19.978h14.431c11.032,0,19.978-8.946,19.978-19.978 v-43.286h-54.385v43.286H291.013z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#578CAD"
  },
  d: "M212.753,284.442l0.001-0.003c0,0-90.999-4.437-90.999,65.486c0,35.701,0,58.567,0,72.42 c0,17.498,13.435,18.255,15.206,18.279h29.642V340.577C166.603,312.766,186.452,289.597,212.753,284.442z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#578CAD"
  },
  d: "M299.899,284.442l-0.001-0.003c0,0,90.999-4.437,90.999,65.486c0,35.701,0,58.567,0,72.42 c0,17.498-13.435,18.255-15.205,18.279h-29.643V340.577C346.049,312.766,326.203,289.597,299.899,284.442z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M282.263,192.01c0-4.48-3.631-8.112-8.112-8.112h-88.626c-6.542,0-11.866-5.322-11.866-11.866 v-52.164c0-6.543,5.324-11.866,11.866-11.866H326.48c6.541,0,11.864,5.322,11.864,11.866v52.164 c0,6.543-5.322,11.866-11.864,11.866h-24.207c-4.481,0-8.112,3.632-8.112,8.112c0,4.48,3.631,8.112,8.112,8.112h24.207 c15.487,0,28.088-12.6,28.088-28.09v-52.164c0-15.488-12.599-28.09-28.088-28.09H185.523c-15.488,0-28.09,12.6-28.09,28.09v52.164 c0,15.488,12.6,28.09,28.09,28.09h88.626C278.631,200.121,282.263,196.49,282.263,192.01z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M356.27,286.44c-12.955-5.608-26.593-8.157-37.282-9.293c48.91-23.539,82.749-73.596,82.749-131.409 C401.738,65.378,336.36,0,256.001,0C175.64,0,110.262,65.378,110.262,145.737c0,57.861,33.896,107.951,82.872,131.466 c-10.608,1.164-24.011,3.721-36.752,9.237c-27.96,12.103-42.739,34.056-42.739,63.485v72.42c0,20.623,15.179,26.28,23.207,26.391 c0.037,0,0.074,0,0.111,0h21.53v35.174c0,15.488,12.6,28.09,28.091,28.09h14.433c15.488,0,28.09-12.6,28.09-28.09v-35.174h53.796 v35.174c0,15.488,12.6,28.09,28.09,28.09h14.431c15.488,0,28.09-12.6,28.09-28.09v-35.174h22.183c0.037,0,0.074,0,0.111,0 c8.026-0.11,23.205-5.768,23.205-26.391v-72.42C399.009,320.497,384.23,298.544,356.27,286.44z M220.992,432.512h-46.277V397.16 h162.571v35.352h-46.273H220.992z M174.775,338.222c0.014-0.294,0.039-0.585,0.058-0.878c0.031-0.477,0.064-0.953,0.109-1.427 c0.035-0.369,0.079-0.735,0.122-1.102c0.045-0.385,0.092-0.769,0.146-1.151c0.058-0.413,0.123-0.824,0.193-1.234 c0.053-0.318,0.11-0.634,0.17-0.95c0.085-0.453,0.174-0.904,0.273-1.353c0.054-0.247,0.112-0.49,0.17-0.735 c0.118-0.504,0.238-1.007,0.371-1.506c0.031-0.118,0.068-0.234,0.101-0.352c0.699-2.527,1.594-4.976,2.673-7.333 c0.055-0.121,0.108-0.243,0.164-0.365c0.228-0.489,0.468-0.97,0.713-1.45c0.094-0.185,0.188-0.371,0.284-0.554 c0.228-0.437,0.465-0.869,0.706-1.298c0.13-0.23,0.262-0.459,0.395-0.686c0.225-0.386,0.454-0.77,0.691-1.15 c0.175-0.282,0.357-0.56,0.538-0.838c0.21-0.322,0.419-0.646,0.636-0.964c0.27-0.396,0.552-0.784,0.834-1.171 c0.142-0.195,0.279-0.394,0.423-0.586c1.397-1.86,2.922-3.619,4.564-5.262c0.004-0.004,0.01-0.009,0.014-0.014 c4.428-4.426,9.695-8.011,15.539-10.497c0.063-0.027,0.125-0.052,0.189-0.078c0.62-0.261,1.247-0.506,1.879-0.742 c0.17-0.063,0.341-0.124,0.512-0.186c0.52-0.187,1.047-0.363,1.575-0.534c0.254-0.081,0.508-0.163,0.766-0.24 c0.439-0.133,0.883-0.256,1.327-0.377c0.332-0.09,0.662-0.182,0.997-0.266c0.355-0.089,0.713-0.167,1.071-0.248 c0.416-0.094,0.831-0.191,1.251-0.275c3.103-0.618,6.31-0.947,9.591-0.947h64.365c27.075,0,49.103,22.028,49.103,49.103v40.358 H174.715v-40.358C174.715,339.788,174.738,339.003,174.775,338.222z M126.486,145.737c0-71.414,58.101-129.513,129.514-129.513 c71.413,0,129.512,58.1,129.512,129.513s-58.098,129.513-129.512,129.513S126.486,217.151,126.486,145.737z M129.867,422.344 v-72.42c0-23.098,10.781-38.996,32.96-48.597c4.07-1.761,8.235-3.176,12.341-4.31c-0.454,0.508-0.891,1.033-1.33,1.555 c-0.157,0.186-0.319,0.367-0.474,0.555c-0.416,0.506-0.814,1.026-1.216,1.546c-2.012,2.599-3.835,5.35-5.444,8.238 c-0.01,0.018-0.021,0.036-0.031,0.054c-0.448,0.806-0.873,1.622-1.287,2.449c-0.034,0.066-0.068,0.13-0.101,0.196 c-0.396,0.796-0.771,1.603-1.135,2.416c-0.045,0.102-0.093,0.203-0.138,0.305c-0.347,0.786-0.675,1.582-0.991,2.384 c-0.055,0.14-0.11,0.277-0.164,0.416c-0.299,0.774-0.581,1.556-0.851,2.344c-0.062,0.178-0.122,0.357-0.182,0.536 c-0.252,0.756-0.49,1.519-0.714,2.288c-0.066,0.226-0.13,0.454-0.194,0.681c-0.204,0.731-0.399,1.466-0.579,2.206 c-0.069,0.283-0.132,0.568-0.198,0.852c-0.159,0.695-0.311,1.392-0.448,2.095c-0.069,0.356-0.129,0.715-0.191,1.073 c-0.114,0.645-0.227,1.288-0.321,1.939c-0.066,0.451-0.117,0.907-0.173,1.361c-0.07,0.571-0.147,1.141-0.203,1.716 c-0.058,0.599-0.095,1.203-0.137,1.805c-0.031,0.447-0.072,0.889-0.095,1.338c-0.052,1.065-0.081,2.135-0.081,3.211v48.47v43.464 h-21.464C133.749,432.45,129.867,430.628,129.867,422.344z M212.88,483.91c0,6.543-5.324,11.866-11.866,11.866h-14.433 c-6.544,0-11.867-5.322-11.867-11.866v-35.174h38.165v35.174H212.88z M337.286,483.91c0,6.543-5.324,11.866-11.866,11.866h-14.431 c-6.543,0-11.866-5.322-11.866-11.866v-35.174h38.162v35.174H337.286z M382.785,422.344c0,8.283-3.881,10.106-7.158,10.167h-21.466 v-91.934c0-16.54-6.246-31.897-16.677-43.56c4.107,1.135,8.271,2.549,12.341,4.31c22.179,9.601,32.96,25.497,32.96,48.597 L382.785,422.344L382.785,422.344z"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.2
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M143.027,145.737c0-71.854,55.068-130.834,125.301-137.069c-4.061-0.361-8.171-0.556-12.327-0.556 c-76.008,0-137.626,61.617-137.626,137.625s61.618,137.625,137.626,137.625c4.155,0,8.265-0.195,12.326-0.556 C198.095,276.571,143.027,217.591,143.027,145.737z"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.2
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M190.199,172.033v-52.164c0-11.033,8.946-19.978,19.978-19.978h-24.653 c-11.032,0-19.978,8.945-19.978,19.978v52.164c0,11.033,8.946,19.978,19.978,19.978h24.653 C199.144,192.01,190.199,183.066,190.199,172.033z"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.2
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M248.471,283.362h-24.653c-31.6,0-57.214,25.617-57.214,57.215v100.046h24.653V340.577 C191.256,308.98,216.871,283.362,248.471,283.362z"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.2
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M191.256,483.91v-43.286h-24.653v43.286c0,11.032,8.945,19.978,19.979,19.978h14.433 c1.769,0,3.476-0.252,5.111-0.685C197.57,500.942,191.256,493.174,191.256,483.91z"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.2
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M315.665,483.91v-43.286h-24.653v43.286c0,11.032,8.943,19.978,19.978,19.978h14.431 c1.771,0,3.477-0.252,5.111-0.685C321.976,500.942,315.665,493.173,315.665,483.91z"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "opacity": 0.2
  }
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#231F20"
  },
  d: "M146.408,422.344c0-13.853,0-36.719,0-72.42c0-39.057,28.392-54.91,53.458-61.298 c4.064-1.875,8.377-3.301,12.887-4.185l0.001-0.003c0,0-90.999-4.437-90.999,65.486c0,35.701,0,58.567,0,72.42 c0,17.498,13.435,18.255,15.206,18.279h24.653C159.843,440.599,146.408,439.842,146.408,422.344z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/astronaute.dea7c554.svg";
export { SvgComponent as ReactComponent };